module.exports = __webpack_public_path__ + "static/media/icon-static-segment-white.51d97436.svg";